import React, { useEffect, useRef } from "react";

const Starfield = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    function resizeCanvas() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }
    
      resizeCanvas(); // set initial size
      window.addEventListener("resize", resizeCanvas); // update on window resize
    
      let width = canvas.width;
      let height = canvas.height;

    let stars = [];
    const starCount = 100;
    for (let i = 0; i < starCount; i++) {
    stars.push({
        x: (Math.random() - 0.5) * width,
        y: (Math.random() - 0.5) * height,
        z: Math.random() * width
    });
    }

    const animate = () => {
      ctx.fillStyle = "#000";
      ctx.fillRect(0, 0, width, height);

      for (let i = 0; i < starCount; i++) {
        let star = stars[i];
        star.z -= .3;

        if (star.z <= 0) {
          star.z = width;
        }

        let k = 128.0 / star.z;
        let x = star.x * k + width / 2;
        let y = star.y * k + height / 2;

        if (x < 0 || x >= width || y < 0 || y >= height) continue;

        let size = Math.max((1 - star.z / width) * 2, 0.5);
        let shade = parseInt((1 - star.z / width) * 255);
        ctx.fillStyle = `rgb(${shade},${shade},${shade})`;

        if (size > 0) {
            ctx.beginPath();
            ctx.arc(x, y, size, 0, Math.PI * 2);
            ctx.fill();
        }
      }

      requestAnimationFrame(animate);
    };

    animate();

    const handleResize = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: -1,
        width: "100vw",
        height: "100vh",
      }}
    />
  );
};

export default Starfield;
